import { memo } from 'react';
import { Pressable } from 'react-native';
import { Box, Icon, Image, Text } from '@betty/moonlight';
import { PaymentProps } from './Payment.types';

function Payment({
  image,
  icon,
  imageWidth,
  imageHeight,
  imageBackground,
  titleKey,
  subtitleKey,
  badgeKey,
  onPress,
}: PaymentProps) {
  return (
    <Pressable onPress={onPress}>
      <Box
        flexDirection="row"
        alignItems="center"
        borderRadius="radius-200"
        paddingVertical="space-300"
        paddingHorizontal="space-400"
        backgroundColor="primaryBackground"
        gap="space-400"
      >
        <Box
          width={56}
          height={40}
          backgroundColor={imageBackground}
          borderRadius="radius-100"
          centerContent
        >
          {icon ? (
            <Icon name={icon} width={imageWidth} height={imageHeight} />
          ) : null}
          {image ? (
            <Image name={image} width={imageWidth} height={imageHeight} />
          ) : null}
        </Box>
        <Box flex={1}>
          <Text
            variant="body-m"
            locNS="wallet"
            locKey={titleKey}
            color="darkSurfacePrimary"
          />
          <Text
            variant="caption"
            locNS="wallet"
            locKey={subtitleKey}
            color="darkSurfaceWashed"
          />
          {badgeKey && (
            <Box
              variant="outline-gradient"
              paddingVertical="space-100"
              paddingHorizontal="space-200"
              alignSelf="flex-start"
              marginTop="space-200"
              borderRadius="radius-full"
            >
              <Text
                variant="caption-semi"
                locNS="wallet"
                locKey={badgeKey}
                gradient="darkSurfaceAccent"
              />
            </Box>
          )}
        </Box>
        <Icon name="arrowForwardIosOutlined" color="iconSecondary" />
      </Box>
    </Pressable>
  );
}

export default memo(Payment);
